import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import SafeIcon from '../../common/SafeIcon';

const CAMP_APP_URL = 'https://camp.gospelwiseauthor.com';
const HUB_LOGIN_URL = `https://gospelwiseauthor.app/#/login?redirect=${encodeURIComponent(CAMP_APP_URL)}`;

export default function AuthHandoff() {
  const { adminLogin, user } = useAuth();
  const [showAdmin, setShowAdmin] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  if (user) {
    const safeUser = Array.isArray(user) ? user[0] : user;

    if (safeUser?.id === 'master-admin') {
      return <Navigate to="/admin" replace />;
    }

    return <Navigate to="/dashboard" replace />;
  }

  const handleAdminSubmit = (event) => {
    event.preventDefault();
    setError('');

    if (!adminLogin(email, password)) {
      setError('Invalid admin credentials.');
    }
  };

  const hasTokenInUrl = Boolean(
    new URLSearchParams(window.location.search).get('token')
    || window.location.hash.includes('?token=')
  );

  if (hasTokenInUrl) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center p-4">
        <Card className="max-w-md w-full text-center space-y-6">
          <div className="mx-auto w-16 h-16 bg-forest-green rounded-full flex items-center justify-center mb-4 text-white">
            <SafeIcon name="Shield" className="text-3xl animate-pulse" />
          </div>
          <h1 className="text-2xl font-bold text-dark-green">Authenticating...</h1>
          <p className="text-muted">Securely connecting your camper profile.</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-4">
      <Card className="max-w-md w-full text-center space-y-6 shadow-lg border-tan">
        <div className="mx-auto w-16 h-16 bg-forest-green rounded-full flex items-center justify-center mb-4 text-white">
          <SafeIcon name="Compass" className="text-3xl" />
        </div>

        {!showAdmin ? (
          <>
            <h1 className="text-2xl font-bold text-dark-green">Welcome to GospelWise Author Camp</h1>
            <p className="text-muted mb-6">
              Please log in through the GospelWise Author Hub to access your camp dashboard and materials.
            </p>
            <div className="pt-2 flex flex-col gap-3">
              <Button className="w-full text-lg py-3" onClick={() => { window.location.href = HUB_LOGIN_URL; }}>
                Login via GWA Hub
              </Button>
              <Button
                variant="outline"
                className="w-full text-lg py-3 border-2 border-forest-green"
                onClick={() => { window.location.href = '/#/register'; }}
              >
                Create Free Account
              </Button>
            </div>
            <div className="pt-8 mt-4">
              <button
                onClick={() => setShowAdmin(true)}
                className="text-xs text-muted hover:text-forest-green flex items-center justify-center gap-2 w-full transition-colors"
              >
                <SafeIcon name="Lock" className="text-xs" /> Login as Admin
              </button>
            </div>
          </>
        ) : (
          <form onSubmit={handleAdminSubmit} className="space-y-4 text-left">
            <h1 className="text-2xl font-bold text-dark-green text-center">Admin Access</h1>
            <p className="text-sm text-muted text-center mb-6">Enter master admin credentials</p>

            {error && (
              <div className="p-3 bg-red-50 border border-red-200 text-red-600 text-sm rounded-md text-center">
                {error}
              </div>
            )}

            <Input
              label="Email Address"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              placeholder="team@gospelwiseauthor.com"
            />
            <Input
              label="Password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
              placeholder="••••••••"
            />

            <div className="pt-4 space-y-3">
              <Button type="submit" className="w-full py-2.5">Secure Login</Button>
              <button
                type="button"
                onClick={() => {
                  setShowAdmin(false);
                  setError('');
                  setPassword('');
                }}
                className="w-full text-sm font-medium text-muted hover:text-dark-green py-2 transition-colors"
              >
                Cancel
              </button>
            </div>
          </form>
        )}
      </Card>
    </div>
  );
}